export default {"src":"/_next/static/media/samsungbrowser.beb1059c.gif","height":422,"width":918,"blurWidth":0,"blurHeight":0};